import { DOWNLOAD_FILE_TYPES } from './types';
export const DEFAULT_REQUEST_TIMEOUT = 10000;
export const ORIGIN_BY_ENV = {
    dev: 'http://localhost:8080',
    'native-qa7': 'https://app.qa7.vocal-qa.com',
    panther: 'https://app.panther.vocal-dev.com',
    prod: 'https://app.vonage.com',
    qa7: 'https://app.qa7.vocal-qa.com'
};
export const ANDROID_USER_AGENT = 'AndroidMFO';
export const IOS_CORDOVA_USER_AGENT = 'iOSMFOCordova';
export const VBC_ACTION = 'VBCAction';
export const EVENTS_REQUIRING_CACHE = ['notification-clicked'];
export const ACTIONS = {
    addContact: {
        id: '',
        parameters: { contact: {} },
        type: 'add-contact'
    },
    downloadFile: {
        id: '',
        parameters: {
            name: '',
            url: '',
            type: DOWNLOAD_FILE_TYPES.general,
            thumbnail: ''
        },
        type: 'download-file'
    },
    executeVBCAction: {
        id: '',
        parameters: { vbcAction: {}, context: {} },
        type: 'execute-vbc-action'
    },
    getAccessToken: {
        id: '',
        parameters: {},
        type: 'get-access-token'
    },
    getApplicationSettings: {
        id: '',
        parameters: {},
        type: 'get-application-settings'
    },
    getCallLog: {
        id: '',
        parameters: { startTime: '', size: 0 },
        type: 'get-call-log'
    },
    getContacts: {
        id: '',
        parameters: {},
        type: 'get-contacts'
    },
    getPresence: {
        id: '',
        parameters: {},
        type: 'get-presence'
    },
    getUserInfo: {
        id: '',
        parameters: {},
        type: 'get-user-info'
    },
    hangupCall: {
        id: '',
        parameters: {
            callId: ''
        },
        type: 'hangup-call'
    },
    makeCall: {
        id: '',
        parameters: {
            toNumber: ''
        },
        type: 'make-call'
    },
    manageCalls: {
        id: '',
        parameters: {
            manageCalls: true,
            showIncomingCallNotification: false,
            showIncomingCallScreen: false,
            showOngoingCallScreen: false,
            suppressOutboundCalls: false
        },
        type: 'manage-calls'
    },
    muteCall: {
        id: '',
        parameters: {
            callId: ''
        },
        type: 'mute-call'
    },
    openPopup: {
        id: '',
        parameters: {
            isModal: 'true',
            popupConfig: {
                type: 'iframe',
                url: ''
            },
            size: 'xlarge',
            title: ''
        },
        type: 'open-popup'
    },
    searchContactById: {
        id: '',
        parameters: { id: '' },
        type: 'search-contact-by-id'
    },
    searchContactByNumber: {
        id: '',
        parameters: { numbers: [] },
        type: 'search-contact-by-number'
    },
    sendDTMF: {
        id: '',
        parameters: {
            callId: '',
            digit: ''
        },
        type: 'send-dtmf'
    },
    recordCall: {
        id: '',
        parameters: {
            callId: ''
        },
        type: 'record-call'
    },
    sendMessage: {
        id: '',
        parameters: {
            body: '',
            id: '',
            number: ''
        },
        type: 'send-message-to-contact'
    },
    setActiveRouteId: {
        id: '',
        parameters: {
            routeContext: {},
            routeId: ''
        },
        type: 'set-active-route-id'
    },
    setAppBadge: {
        id: '',
        parameters: {
            appId: '',
            counter: 0
        },
        type: 'set-app-badge'
    },
    setAppTitleBarPlugin: {
        id: '',
        parameters: {
            plugin: {}
        },
        type: 'set-app-title-bar-plugin'
    },
    setConversationMessages: {
        id: '',
        parameters: {
            conversationId: '',
            messages: []
        },
        type: 'set-conversation-messages'
    },
    setWidgetMode: {
        id: '',
        parameters: { widgetMode: false },
        type: 'set-widget-mode'
    },
    showNotification: {
        id: '',
        parameters: {
            notification: {
                body: '',
                icon: '',
                title: ''
            },
            route: {
                routeContext: {},
                routeId: ''
            },
            settings: {
                onlyOnBackground: false
            },
            sound: ''
        },
        type: 'show-notification'
    },
    toggleFavorite: {
        id: '',
        parameters: { contact: {} },
        type: 'toggle-favorite'
    },
    trackAnalyticsEvent: {
        id: '',
        parameters: { eventType: '', eventProps: {}, userId: '' },
        type: 'track-analytics-event'
    },
    useContactsService: {
        id: '',
        parameters: { type: '', payload: {} },
        type: 'use-contacts-service'
    }
};
export var HOST_TYPE;
(function (HOST_TYPE) {
    HOST_TYPE["IOS_CORDOVA"] = "ios-cordova";
    HOST_TYPE["ANDROID"] = "android";
    HOST_TYPE["IFRAME"] = "iframe";
    HOST_TYPE["WEB_COMPONENT"] = "webcomponent";
})(HOST_TYPE || (HOST_TYPE = {}));
//# sourceMappingURL=data:application/json;base64,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